import { createState, State } from '@hookstate/core';
import { createContext } from 'react';

export const disabledContext = createContext<State<Record<string, boolean>>>(createState<Record<string, boolean>>({}));
